import { defineMessages } from "react-intl";

export const waitingListReportMessages = defineMessages({
  title: {
    id: "waitingListReportMessages.title",
    defaultMessage: "Waiting List Report",
  },
  countTitle: {
    id: "waitingListReportMessages.countTitle",
    defaultMessage: "Total registered",
  },
  countTooltip: {
    id: "waitingListReportMessages.countTooltip",
    defaultMessage: "Registrations for future dates (relative to the current day)",
  },
  export: {
    id: "waitingListReportMessages.export",
    defaultMessage: "Export Excel",
  },
  typeFilterPlaceholder: {
    id: "waitingListReportMessages.typeFilterPlaceholder",
    defaultMessage: "Type",
  },
  typeEventItemCreated: {
    id: "waitingListReportMessages.typeEventItemCreated",
    defaultMessage: "Subscription Created",
  },
  typeEventEmailSent: {
    id: "waitingListReportMessages.typeEventEmailSent",
    defaultMessage: "Email Sent",
  },
  startDate: {
    id: "default.startDate",
    defaultMessage: "startDate",
  },
  endDate: {
    id: "default.endDate",
    defaultMessage: "endDate",
  },
});
